import React from 'react';
import { Icon, Title } from '@gerdau/hefesto';
import { Container } from './styles';

const NoProductBlock: React.FC = () => {
  return (
    <Container>
      <Icon option="ImagePlaceholder" variant="tertiary" size="full" />
      <Title level={5}>Nenhum produto aqui</Title>
      <p>Adicione produtos para habilitar a simulação</p>
    </Container>
  );
};

export default NoProductBlock;
